import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormActions } from '../../../components/form/index.js';
import Table from '../../../components/Table.tsx';
import { useMeasurementUnitsContext } from '../../../contexts/measurementUnits/measurementUnits.tsx';

const MeasurementUnitsBody = () => {
    const {measurementUnits, deleteMeasurementUnit } = useMeasurementUnitsContext();
    const navigate = useNavigate();
    const columns = [
        {
            header: "name",
            name: "name",
            enableSorting: true,
            cell: (props: any) => {
                const { measurementUnitID, name } = props.row;
                return (
                    <Link className="nav-link" to={`/admin/measurement-units/${measurementUnitID}`}>
                        <span >{name}</span>
                    </Link>
                );
            }
        },
        {
            header: "",
            name: "delete",
            actionHandler: (props: any) => {
                const { measurementUnitID } = props.row;
                return deleteMeasurementUnit(measurementUnitID);
            },
            enableSorting: false
        }
    ]

    return (
        <>
            <Table columns={columns} rows={measurementUnits} />
            <FormActions
                mainAction={() => { navigate("/admin/measurement-units/create"); }}
                mainActionText="Create"
            />
        </>
    );
};

export default MeasurementUnitsBody;